import React, { useState } from "react";
import { useAnalysis } from "../../contexts/AnalysisContext";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc} from "firebase/firestore";
import { FaTimes } from "react-icons/fa";
import { useGeoJson } from "../../contexts/GeoJsonContext";

const AreaDetailSidebar = ({ onCancel, area, kmlCoordinates, setSelector }) => {
  const { geoArea } = useGeoJson();
  const [fieldName, setFieldName] = useState("");
  const [season, setSeason] = useState("");
    const [newField, setNewField] = useState(false);
  const [sowingDate, setSowingDate] = useState("");
  const [harvestingDate, setHarvestingDate] = useState("");
  const [fertilizerApplication, setFertilizerApplication] = useState("");
  const [cropName, setCropName] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { setToastMsg, setaddFieldTime } = useAnalysis();
  const { polygon } = useAnalysis();

  const handleConfirmClick = async () => {
    if (!fieldName.trim() ) {
      setError("Field name is required.");
      return;
    }
    else if(!cropName.trim()){
      setError("Crop Name is required.");
      return;
    }
    else if(!sowingDate.trim()){
      setError("Sowing Date is required.");
      return;
    }
    else if(fieldName.includes('-')){
      setError("Hyphens (-) are not allowed.");
      return;
    }

    if (!polygon && !kmlCoordinates) {
      setError("No polygon or KML coordinates available.");
      return;
    }

    setIsLoading(true);

    await saveFieldData();
    setSelector(false);
    onCancel();
  };

  const saveFieldData = async () => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        const db = getFirestore();

        let transformedCoordinates = [];

        // Save KML Coordinates if available
        if (kmlCoordinates && kmlCoordinates.length > 0) {
          transformedCoordinates = kmlCoordinates.map((coord) => ({
            latitude: coord[0],
            longitude: coord[1],
          }));
        }
        // Otherwise, save polygon data if available
        else if (polygon && polygon.geometry && polygon.geometry.coordinates) {
          transformedCoordinates = polygon.geometry.coordinates[0].map(
            (coord) => ({
              latitude: coord[1],
              longitude: coord[0],
            })
          );
        }

        const randomNumber = Math.floor(Math.random() * 10000);
        let uniqueFieldName = `${fieldName}-${randomNumber}`;
        
        // Get current date and time
        const createdAt = new Date(); // This will be the current date and time
        
        await addDoc(collection(db, `users/${user.uid}/fields`), {
          fieldName: uniqueFieldName,
          coordinates: transformedCoordinates,
          area: area?.acres || geoArea || null,
          season: season || null,
          sowingDate,
          harvestingDate,
          fertilizerApplication,
          cropName,
          createdAt: createdAt, // Save the current date and time
          timestamp: createdAt.getTime() // Optional: Also save as timestamp for easier sorting
        });
        
        localStorage.setItem("sowingDate", sowingDate);
        
        
        setToastMsg({
          isShown: true,
          message: "Field data saved successfully.",
          type: "success",
        });
        setNewField(true);
        localStorage.setItem("newField", "true");
        const date = new Date();
        const formattedTime = date.toLocaleString();
        setaddFieldTime(formattedTime);
      } else {
        throw new Error("User must be authenticated to save field data.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="fixed top-0 right-0 left-0 bg-black bg-opacity-60 h-screen w-full z-[500] flex items-center justify-center">
        <div
          className={`bg-white p-5 rounded-lg flex flex-col justify-center py-3 w-[270px] lg:w-96 overflow-hidden z-[500] shadow-md shadow-black relative`}
        >
          <span
            className="absolute top-2 right-2 flex items-center justify-center bg-gray-300 w-[30px] h-[30px] rounded-full cursor-pointer hover:scale-105"
            onClick={onCancel}
          >
            <FaTimes size={20} />
          </span>
          {error && <div className="text-red-400">{error}</div>}
          <div className="mt-4">
            <label htmlFor="fieldName" className="font-medium">
              Field Name   <span className='text-red-500'>*</span>
            </label>

            <input
              id="fieldName"
              type="text"
              value={fieldName}
              onChange={(e) => setFieldName(e.target.value)}
              placeholder="Enter Field Name"
              className="w-full h-12 px-2 rounded border border-gray-300 bg-slate-100"
            />
          </div>
          <div className="mt-4">
            <label htmlFor="cropName" className="font-medium">
              Crop Name <span className='text-red-500'>*</span>
            </label>
            <input
              id="cropName"
              type="text"
              value={cropName}
              onChange={(e) => setCropName(e.target.value)}
              placeholder="Enter Crop Name"
              required={true}
              className="w-full h-12 px-2 rounded border border-gray-300 bg-slate-100"
            />
          </div>
          <div className="mt-4">
            <label htmlFor="season" className="font-medium">
              Season
            </label>
            <input
              id="season"
              type="text"
              value={season}
              onChange={(e) => setSeason(e.target.value)}
              placeholder="Enter season"
              className="w-full h-12 px-2 rounded border border-gray-300 bg-slate-100"
            />
          </div>
          <div className="mt-4">
            <label htmlFor="sowingDate" className="font-medium">
              Sowing Date   <span className='text-red-500'>*</span>
            </label>

            <input
              id="sowingDate"
              type="date"
              value={sowingDate}
              onChange={(e) => setSowingDate(e.target.value)}
              required={true}
              className="w-full h-12 px-2 rounded border border-gray-300 bg-slate-100"
            />
          </div>
          <div className="mt-4">
            <label htmlFor="harvestingDate" className="font-medium">
              Harvesting Date
            </label>

            <input
              id="harvestingDate"
              type="date"
              value={harvestingDate}
              onChange={(e) => setHarvestingDate(e.target.value)}
              required={true}
              className="w-full h-12 px-2 rounded border border-gray-300 bg-slate-100"
            />
          </div>
          <div className="mt-4">
            <label htmlFor="fertilizerApplication" className="font-medium">
              Fertilizer Application
            </label>
            <input
              id="fertilizerApplication"
              type="text"
              value={fertilizerApplication}
              onChange={(e) => setFertilizerApplication(e.target.value)}
              className="w-full h-12 px-2 rounded border border-gray-300 bg-slate-100"
            />
          </div>
          <button
            onClick={() => {
              handleConfirmClick();

            }}

            disabled={isLoading}
            className="w-full h-12 mt-4 rounded-md bg-[#3b82f6] font-medium text-white hover:bg-blue-600 hover:text-white"
          >
            {isLoading ? "Saving..." : "Confirm"}
          </button>
        </div>
        
      </div>
    </>
  );
};

export default AreaDetailSidebar;